import React from 'react';
import {
  Home,
  User,
  Briefcase,
  GraduationCap,
  Code,
  Globe,
  FileText,
  Award,
  Settings,
  List,
  UserRound,
  Heart,
} from 'lucide-react';
import useGlobale from './global';

// Définir tous les éléments de menu possibles
const allMenuItems = [
  { 
    icon: <Home />, 
    label: 'Tableau de bord', 
    path: '/',
    forAdmin: true,
    forUser: true
  },
 
  { 
    icon: <List />, 
    label: 'Liste des demandeurs', 
    path: '/liste-demandeurs',
    forAdmin: true,
    forUser: false
  },
  { 
    icon: <User />, 
    label: 'Mon profil', 
    path: '/profile',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <Award />, 
    label: 'Mes diplômes', 
    path: '/diplomes',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <Briefcase />, 
    label: 'Mes expériences', 
    path: '/experiences',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <GraduationCap />, 
    label: 'Mes formations', 
    path: '/formations',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <Code />, 
    label: 'Mes compétences', 
    path: '/competences',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <Globe />, 
    label: 'Mes langues', 
    path: '/langues',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <FileText />, 
    label: 'Mes documents', 
    path: '/documents',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <Heart />, 
    label: 'Centres d\'intérêt', 
    path: '/centres-interet',
    forAdmin: false,
    forUser: true
  },
  { 
    icon: <UserRound />, 
    label: 'Gestion des comptes', 
    path: '/gestion-des-comptes',
    forAdmin: true,
    forUser: false
  },
  { 
    icon: <Settings />, 
    label: 'Paramètres', 
    path: '/parametres',
    forAdmin: true,
    forUser: false
  }
];

// Fonction qui retourne le menu approprié en fonction du statut de l'utilisateur
const DemandeurMenu = () => {
  const { user } = useGlobale();
  
  // Déterminer si l'utilisateur est un superuser
  const isSuperUser = user?.is_superuser === true;
  
  // Filtrer les éléments du menu selon le rôle de l'utilisateur
  const filteredMenu = allMenuItems.filter(item => 
    (isSuperUser && item.forAdmin) || (!isSuperUser && item.forUser)
  );
  
  return filteredMenu;
};

export default DemandeurMenu; 